// Teleport destinations on the grid (Cloud's Jaunt, Blink Steps): the creature's footprint moves to a square within
// reach (Chebyshev squares, 5 feet each), stays on the map and overlaps no other creature's footprint. Sight and walls
// are left to the table. No imports, so both the server check and the map's square highlights can load it.

/** Whether two square footprints (top-left anchors, side in squares) overlap. */
export const footprintsOverlap = (a, aSize, b, bSize) => a.x < b.x + bSize && b.x < a.x + aSize && a.y < b.y + bSize && b.y < a.y + aSize;

/** The distance in feet between two anchors. */
export const teleportFeet = (origin, destination) => Math.max(Math.abs(destination.x - origin.x), Math.abs(destination.y - origin.y)) * 5;

/**
 * Why a destination anchor is not allowed: 'off-map', 'same', 'too-far' or 'occupied'; null when it is allowed.
 * `blockers` are the other creatures' footprints `{ x, y, size }`.
 */
export const teleportProblem = ({ origin, destination, size = 1, maxFeet, columns, rows, blockers = [] }) => {
  if (!origin || !destination || destination.x < 0 || destination.y < 0 || destination.x > columns - size || destination.y > rows - size) return 'off-map';
  const feet = teleportFeet(origin, destination);
  if (!feet) return 'same';
  if (feet > maxFeet) return 'too-far';
  if (blockers.some(blocker => footprintsOverlap(destination, size, blocker, blocker.size || 1))) return 'occupied';
  return null;
};

/** Every allowed destination anchor, for highlighting the squares a creature can teleport to. */
export const teleportSquares = ({ origin, size = 1, maxFeet, columns, rows, blockers = [] }) => {
  if (!origin) return [];
  const reach = Math.floor(maxFeet / 5);
  const squares = [];
  for (let y = Math.max(0, origin.y - reach); y <= Math.min(rows - size, origin.y + reach); y += 1) {
    for (let x = Math.max(0, origin.x - reach); x <= Math.min(columns - size, origin.x + reach); x += 1) {
      if (!teleportProblem({ origin, destination: { x, y }, size, maxFeet, columns, rows, blockers })) squares.push({ x, y });
    }
  }
  return squares;
};
